import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useError, useForm } from '../../hooks'

import TextField from '../Form/TextField'
import Button from '../Button'
import ContextMenu from '../ContextMenu'
import LocationForm, { parseLocation } from '../LocationForm'

import { auth, db } from '../../firebase'
import { doc, setDoc, serverTimestamp, getDoc } from 'firebase/firestore'
import { useIdGenerator } from '../../hooks/useidgenerator'

export default function CreateSite() {
  const navigate = useNavigate()
  const setError = useError()
  const [getFieldProps, formData, formError] = useForm()
  const { generateSiteId } = useIdGenerator()
  const user = auth.currentUser

  async function handleSubmit(e) {
    e.preventDefault()
    const { name } = formData
    let location

    try {
      location = parseLocation(formData)
    } catch (err) {
      if (err.message === 'invalid_format') {
        formError({ format: 'Invalid location format.' })
      } else {
        setError(err)
      }
      return
    }

    try {
      // ✅ get the user document from Firestore
      const userRef = doc(db, 'users', user.uid)
      const userSnap = await getDoc(userRef)

      if (!userSnap.exists()) {
        throw new Error('User not found in Firestore')
      }

      const userData = userSnap.data()
      const organization = userData?.organization.id || null

      // ✅ generate custom site ID
      const customId = generateSiteId()

      // ✅ create site doc with organization
      await setDoc(doc(db, 'sites', customId.toString()), {
        name,
        locations: [location],
        organization:{
          org_name: userData?.organization.name || 'No Organization',
          org_id: organization
        }, // add organization field
        // organization_bindings is the field mobile queries and the field the Phase 5
        // rules key on. Without it here, a newly created site is invisible to the mobile
        // app and denied by the tenant rule. Stored as a string, matching
        // CreateSiteOrganizationBinding and SiteDetails.
        organization_bindings: organization ? [String(organization)] : [],
        createdAt: new Date().toISOString(),
      })

      navigate(`/sites/${customId.toString()}`)
    } catch (err) {
      console.error(err)
      setError(err)
    }
  }


  return (
    <div className='box'>
      <form onSubmit={handleSubmit}>
        <TextField
          label='Name'
          name='name'
          placeholder='Name'
          required={true}
          {...getFieldProps()}
        />
        <LocationForm getFieldProps={getFieldProps} formData={formData} />
        <br />
        <ContextMenu>
          <Button type='submit'>Create</Button>
        </ContextMenu>
      </form>
    </div>
  )
}
